export const SHORT_STALE_TIME = 60 * 1000;
export const EXTENDED_STALE_TIME = 5 * 60 * 1000;
export const REDIRECT_INFO_DISPLAY_TIME = 3 * 1000;

// Originates from the backend
export const MAX_CURRENCY_AMOUNT = 2147483647;

// The time it takes for a modal to finish its closing animation plus a buffer
export const MODAL_CLOSE_TIMEOUT = 400 + 50; // ms
